/**
 * 删除规则类型
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 删除规则类型
 */
enum GSPDeleteRuleType {
    /**
     * 拒绝删除
     */
    Refuse = 0,

    /**
     * 允许删除
     */
    Allow = 1
}

export { GSPDeleteRuleType };

